import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { MillieAvatar } from "../components/MascotBubble";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        const data = await completeGoogle(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.name?.split(" ")[0] || "friend"}!`);
        navigate("/home", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [completeGoogle, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <MillieAvatar size={72} />
      <p className="font-hand text-2xl text-sorted-ink">Signing you in…</p>
    </div>
  );
}
